import { FilesDragAndDrop } from "./components";

function App() {
  return (
    <div className="bg-gray-100 h-screen w-screen items-center justify-center flex">
      <div className="bg-white shadow-lg p-8 rounded-lg">
        <FilesDragAndDrop />
      </div>
    </div>
  );
}

export default App;
